import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import CollapsibleContainer from '../../components/CollapsibleContainer';
import UpperContainer from '../../components/UpperContainer';
import { animateToScreen } from '../../redux/ui/actions';
import { setTicketPassengers } from '../../redux/cardReader/actions';
import {
  TICKET_TYPE_ADDITIONAL_ZONE,
  MOBILE_BREAKPOINT_IN_PX,
} from '../../constants';
import SeasonalTicketZonesSelector from '../../containers/SeasonalTicketZonesSelector';
import CurrentZoneSelector from '../../containers/CurrentZoneSelector';
import CurrentZoneSelectorWrapper from '../../molecules/CurrentZoneSelectorWrapper';
import BackButtonContainer from '../../molecules/BackButtonContainer';
import TextColumnContent from '../../molecules/TextColumnContent';
import Description from '../../components/Description';
import { H2, H4, Text, TextBig } from '../../components/Typography';

const Disclaimer = styled.div`
  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    padding-left: 20px;
  }
`;

class AdditionalZoneRegionTexts extends PureComponent {
  componentDidMount() {
    this.props.resetPassengers();
  }

  render() {
    const { goBackToHome, t } = this.props;
    return (
      <>
        <BackButtonContainer
          fadeIn
          home={t('Generic.breadcrumbHome')}
          homeLink={t('Generic.breadcrumbHomeLink')}
          secondaryHome={t('Generic.breadcrumbSecondaryHome')}
          secondaryHomeLink={t('Generic.breadcrumbSecondaryHomeLink')}
          textPrev={t('Flows.home')}
          text={t('Flows.additionalZone')}
          onClick={goBackToHome}
        />
        <TextColumnContent paddingTop={-100}>
          <H2>
            <Trans i18nKey="AdditionalZoneRegion.title" />
          </H2>
          <UpperContainer>
            <Description>
              <Text>
                <Trans i18nKey="AdditionalZoneRegion.description" />
              </Text>
            </Description>
            <SeasonalTicketZonesSelector
              ticketType={TICKET_TYPE_ADDITIONAL_ZONE}
            />
            <Disclaimer>
              <H4>
                <Trans i18nKey="AdditionalZoneRegion.disclaimerTitle" />
              </H4>
              <TextBig>
                <Trans i18nKey="AdditionalZoneRegion.disclaimer" />
              </TextBig>
            </Disclaimer>
            <CurrentZoneSelectorWrapper>
              <CurrentZoneSelector
                ticketType={TICKET_TYPE_ADDITIONAL_ZONE}
                additionalInfoI18nKey="AdditionalZoneRegion.disclaimer"
              />
            </CurrentZoneSelectorWrapper>
          </UpperContainer>
          <CollapsibleContainer>
            <Collapsible
              trigger={t('Generic.additionalInfo')}
              transitionTime={300}
            >
              <Description>
                <Text>
                  <Trans i18nKey="AdditionalZoneRegion.description" />
                </Text>
              </Description>
              <SeasonalTicketZonesSelector
                ticketType={TICKET_TYPE_ADDITIONAL_ZONE}
              />
              <Disclaimer>
                <H4>
                  <Trans i18nKey="AdditionalZoneRegion.disclaimerTitle" />
                </H4>
                <TextBig>
                  <Trans i18nKey="AdditionalZoneRegion.disclaimer" />
                </TextBig>
              </Disclaimer>
              <CurrentZoneSelectorWrapper>
                <CurrentZoneSelector
                  ticketType={TICKET_TYPE_ADDITIONAL_ZONE}
                  additionalInfoI18nKey="AdditionalZoneRegion.disclaimer"
                />
              </CurrentZoneSelectorWrapper>
            </Collapsible>
          </CollapsibleContainer>
        </TextColumnContent>
      </>
    );
  }
}

AdditionalZoneRegionTexts.propTypes = {
  goBackToHome: PropTypes.func.isRequired,
  resetPassengers: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  goBackToHome: () => dispatch(animateToScreen('Home')),
  resetPassengers: () => dispatch(setTicketPassengers(TICKET_TYPE_ADDITIONAL_ZONE, 1)), // eslint-disable-line
});

// prettier-ignore
export default connect(null, mapDispatchToProps)(AdditionalZoneRegionTexts);
